import styled from '@emotion/styled';
import { cssMedia } from '@genteras/core-lib/utils/css-utils';
import { Col, Grid, Row } from 'antd';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { StyledButton } from '@/components/base/StyledButton';
import { CarouselBanner } from '@/components/common/CarouselBanner';
import GameItem from '@/components/common/GameItem';
import type { Game } from '@/lib/api/gameLaunch';
import useGameList from '@/lib/hooks/useGameList';

const { useBreakpoint } = Grid;

const Container = styled.div`
  display: flex;
  padding: 40px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
`;

const GameListContainer = styled.div`
  display: flex;
  flex-direction: column;
  // align-items: center;
  gap: 16px;
  align-self: stretch;
  color: 'var(--White)';
`;

const GameSection = styled('div')({
  padding: '0 8px 20px 8px',
  color: 'var(--White)',
  [cssMedia.xl]: {
    margin: '0 0 20px 0',
  },
});

type Props = {
  gameType: string;
};

const GamesPage = (props: Props) => {
  const { gameType } = props;
  const { md } = useBreakpoint();

  const size = md ? 12 : 6;

  const [page, setPage] = useState(10);

  const { t } = useTranslation();
  const { gamesByType } = useGameList();
  const [games, _] = useState<Game[]>(gamesByType[gameType] ?? []);

  const getGames = () => {
    setPage(page + 2);
  };
  const gameSites = [...new Set(games.map((game) => game.gameSite).reverse())];
  return (
    <>
      <CarouselBanner />
      <Container className="main-content-container">
        <GameListContainer>
          {gameType === 'live' ? (
            <Row>
              {gameSites.map((site, i) => {
                return (
                  <Col key={i} span={12}>
                    <h4>{`${t(`gameResult:gameSite.${site}`)}`}</h4>
                    <GameSection>
                      <Row gutter={[16, 16]}>
                        {games
                          .filter((x) => x.gameSite === site)
                          .slice(0, page * size)
                          .map((game, index) => {
                            return (
                              <Col span={12} key={`game-${index}`}>
                                <GameItem game={game} />
                                <span style={{ color: 'white' }}>
                                  {game.gameType === 'live'
                                    ? t(`gameResult:gameType.${game.name}`)
                                    : null}
                                </span>
                              </Col>
                            );
                          })}
                      </Row>
                    </GameSection>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <>
              <h4>{`${t(`common:gameType.${gameType}`)} (${games.length})`}</h4>
              <Row gutter={[16, 16]}>
                {games.slice(0, page * size).map((game, index) => {
                  return (
                    <Col xs={12} sm={8} md={6} key={`game-${index}`}>
                      <GameItem game={game} />
                    </Col>
                  );
                })}
              </Row>
            </>
          )}
          {page * size < games.length ? (
            <StyledButton style={{ width: '100%' }} onClick={getGames}>
              {t('LoadMore')}
            </StyledButton>
          ) : null}
        </GameListContainer>
      </Container>
    </>
  );
};

export default GamesPage;
